import { render, staticRenderFns } from "./investor-deal-origination.vue?vue&type=template&id=685b5cb9&"
import script from "./investor-deal-origination.vue?vue&type=script&lang=js&"
export * from "./investor-deal-origination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685b5cb9')) {
      api.createRecord('685b5cb9', component.options)
    } else {
      api.reload('685b5cb9', component.options)
    }
    module.hot.accept("./investor-deal-origination.vue?vue&type=template&id=685b5cb9&", function () {
      api.rerender('685b5cb9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/blok/conversion/investor-deal-origination.vue"
export default component.exports